import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { Menu, Icon } from 'antd'

const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup

export class InstallJobMenu extends PureComponent {
  getURL = itemKey => {
    const { jobId, jobType } = this.props.match.params
    return `/jobView/${jobId}/${jobType}/${itemKey}`
  }
  render() {
    return (
      <Menu
        onClick={this.props.handleClick}
        selectedKeys={[this.props.currentKey]}
        mode={this.props.screenWidth > 900 ? 'horizontal' : 'inline'}
      >
        <SubMenu
          title={
            <span>
              <Icon type="profile" />Details
            </span>
          }
        >
          <MenuItemGroup title="Job Details">
            <Menu.Item key="Job Attachments">
              <Link to={this.getURL('attachments')}>Attachments</Link>
            </Menu.Item>

            <Menu.Item key="Job Follow Ups">
              <Link to={this.getURL('follow-ups')}>Follow Ups</Link>
            </Menu.Item>
            <Menu.Item key="Job Notes">
              <Link to={this.getURL('notes')}>Notes</Link>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>
        <Menu.Item key="Job Contacts">
          <Link to={this.getURL('contacts')}>
            <Icon type="message" />Contacts
          </Link>
        </Menu.Item>
        <SubMenu
          title={
            <span>
              <Icon type="calendar" />Schedule
            </span>
          }
        >
          <MenuItemGroup title="Job Schedules">
            <Menu.Item key="Schedule Drawings">
              <Link to={this.getURL('schedule-drawings')}>Drawings</Link>
            </Menu.Item>
            <Menu.Item key="Schedule Manufacturing">
              <Link to={this.getURL('manufacturing')}>Manufacturing</Link>
            </Menu.Item>
            <Menu.Item key="Schedule Applications/Permits">
              <Link to={this.getURL('applications')}>Applications/Permits</Link>
            </Menu.Item>
            <Menu.Item key="Schedule Site Work">
              <Link to={this.getURL('sitework')}>Site Work</Link>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>
        <SubMenu
          title={
            <span>
              <Icon type="book" />Financials
            </span>
          }
        >
          <MenuItemGroup title="Job Financials">
            <Menu.Item key="Job Financial Summary">
              <Link to={this.getURL('financial-summary')}>Financial Summary</Link>
            </Menu.Item>
            <Menu.Item key="Job Payment Requests">
              <Link to={this.getURL('payment-requests')}>Payment Requests</Link>
            </Menu.Item>
            <Menu.Item key="Job AIAs">
              <Link to={this.getURL('aias')}>AIAs</Link>
            </Menu.Item>
            <Menu.Item key="Job Invoices">
              <Link to={this.getURL('invoices')}>Invoices</Link>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>
        <Menu.Item key="Job Drawings">
          <Link to={this.getURL('drawings')}>
            <Icon type="api" />Drawings
          </Link>
        </Menu.Item>
        <Menu.Item key="Job Vendors">
          <Link to={this.getURL('vendors')}>
            <Icon type="shop" />Vendors
          </Link>
        </Menu.Item>
        <SubMenu
          title={
            <span>
              <Icon type="solution" />DOB/Violations
            </span>
          }
        >
          <MenuItemGroup title="DOB">
            <Menu.Item key="DOB Attachments">
              <Link to={this.getURL('dob-attachments')}>Attachments</Link>
            </Menu.Item>
            <Menu.Item key="Violations">
              <Link to={this.getURL('violations')}>Violations</Link>
            </Menu.Item>
            <Menu.Item key="DOB Notes">
              <Link to={this.getURL('dob-notes')}>Notes</Link>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>
        <SubMenu
          title={
            <span>
              <Icon type="environment" />Job Site
            </span>
          }
        >
          <MenuItemGroup title="Job Site Management">
            <Menu.Item key="Job Site Overview">
              <Link to={this.getURL('site-overview')}>Overview</Link>
            </Menu.Item>
            <Menu.Item key="Job Site Driver Requests">
              <Link to={this.getURL('driver-requests')}>Driver Requests</Link>
            </Menu.Item>
            <Menu.Item key="Job Site Material Requests">
              <Link to={this.getURL('material-requests')}>Material Requests</Link>
            </Menu.Item>
            <SubMenu title={<span>Change Orders</span>}>
              <Menu.Item key="Job Site Estimates">
                <Link to={this.getURL('site-estimates')}>Estimates</Link>
              </Menu.Item>
              <Menu.Item key="Job Site Change Orders">
                <Link to={this.getURL('change-orders')}>Change Orders</Link>
              </Menu.Item>
            </SubMenu>
            <Menu.Item key="Job Site Work Orders">
              <Link to={this.getURL('work-orders')}>Work Orders</Link>
            </Menu.Item>
            <Menu.Item key="Job Site Job Minutes">
              <Link to={this.getURL('minutes')}>Job Minutes</Link>
            </Menu.Item>
            <Menu.Item key="Job Site Transmittals">
              <Link to={this.getURL('transmittals')}>Transmittals</Link>
            </Menu.Item>
            <Menu.Item key="Job Site RFIs">
              <Link to={this.getURL('site-rfi')}>RFIs</Link>
            </Menu.Item>
            <Menu.Item key="Job Site Documents">
              <Link to={this.getURL('site-documents')}>Documents</Link>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InstallJobMenu.js